import React from 'react';
import { Home, Users, TrendingUp, Image, Shield, Bell, Bookmark, User as UserIcon, Settings, PlusSquare } from 'lucide-react';
import { TabType } from '../../types';
import styles from './Sidebar.module.css';

interface SidebarProps {
  activeTab: TabType;
  setActiveTab: (tab: TabType) => void;
  onOpenCompose: () => void;
  unreadNotifsCount: number;
}

export const Sidebar: React.FC<SidebarProps> = ({
  activeTab,
  setActiveTab,
  onOpenCompose,
  unreadNotifsCount,
}) => {
  const navItems = [
    { id: 'home', label: 'Home Feed', icon: Home },
    { id: 'following', label: 'Following', icon: Users },
    { id: 'trending', label: 'Trending', icon: TrendingUp },
    { id: 'media', label: 'Media Feed', icon: Image },
    { id: 'communities', label: 'Communities', icon: Shield },
    { id: 'notifications', label: 'Notifications', icon: Bell, badge: unreadNotifsCount },
    { id: 'bookmarks', label: 'Bookmarks', icon: Bookmark },
    { id: 'profile', label: 'Profile', icon: UserIcon },
    { id: 'settings', label: 'Settings', icon: Settings },
  ];

  return (
    <aside className={styles.sidebar}>
      {navItems.map((item) => {
        const Icon = item.icon;
        const isActive = activeTab === item.id;
        return (
          <button
            key={item.id}
            className={`${styles.navItem} ${isActive ? styles.active : ''}`}
            onClick={() => setActiveTab(item.id as TabType)}
          >
            <Icon size={20} />
            <span className={styles.label}>{item.label}</span>
            {item.badge && item.badge > 0 ? (
              <span className={styles.badge}>{item.badge}</span>
            ) : null}
          </button>
        );
      })}

      <button className={styles.postCta} onClick={onOpenCompose}>
        <PlusSquare size={20} />
        <span>Create Post</span>
      </button>
    </aside>
  );
};
